var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavRefunds = function SvgNavRefunds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#8FB4EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#NavRefunds_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.375 31.103a8 8 0 0 0-11.345-10.05l-.992-1.737A9.996 9.996 0 0 1 33 19.34c4.49 2.592 6.21 8.142 4.117 12.77l1.342.774-4.165 2.214-.165-4.714 1.246.719Zm-14.75-6.206a8.001 8.001 0 0 0 11.345 10.05l.992 1.737A9.996 9.996 0 0 1 23 36.66c-4.49-2.592-6.21-8.142-4.117-12.77l-1.343-.773 4.165-2.214.165 4.714-1.246-.719.001-.001ZM24.5 30H30a.5.5 0 0 0 0-1h-4a2.5 2.5 0 0 1 0-5h1v-1h2v1h2.5v2H26a.5.5 0 0 0 0 1h4a2.5 2.5 0 1 1 0 5h-1v1h-2v-1h-2.5v-2Z",
    fill: "#247BFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "NavRefunds_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16 16)",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgNavRefunds;